export const FORM_WIDTH = 348;
export const ADMIN_TEXT_WIDTH = 300;

export const COLOR_WHITE = '#fff';

export const COLOR_PRIMARY = '#4ecbc3';

export const COLOR_BUTTON_DISABLED = '#848484';
export const COLOR_DIVIDER = '#dbdbdb';

export const COLOR_333 = '#333';
export const COLOR_F1F3F6 = '#f1f3f6';

//STUB - Paddings
export const PADDING_SIZES = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
};

//STUB - Font sizes
export const FONT_SIZES = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  huge: '32px',
};

//STUB - Font weights
export const FONT_WEIGHTS = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
};
